import { render, staticRenderFns } from "./ConfigureConfig.vue?vue&type=template&id=b95f1500&scoped=true&"
import script from "./ConfigureConfig.vue?vue&type=script&lang=js&"
export * from "./ConfigureConfig.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureConfig.vue?vue&type=style&index=0&id=b95f1500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f1500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95f1500')) {
      api.createRecord('b95f1500', component.options)
    } else {
      api.reload('b95f1500', component.options)
    }
    module.hot.accept("./ConfigureConfig.vue?vue&type=template&id=b95f1500&scoped=true&", function () {
      api.rerender('b95f1500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/ConfigureConfig.vue"
export default component.exports